import type { GroupedSelectOptionType } from '../../utils/form-options';

export const HDE_ATTENDANCE_REASONS: GroupedSelectOptionType[] = [
    { label: 'Meeting Architects', value: 'Meeting Architects' },
    { label: 'Meeting Builders', value: 'Meeting Builders' },
    {
        label: 'Meeting Interior Designers',
        value: 'Meeting Interior Designers',
    },
    {
        label: 'Seeing the latest Products',
        value: 'Product Suppliers',
    },
    { label: 'Tips from the Panel', value: 'Tips from the Panel' },
    { label: 'Networking', value: 'Networking' },
    { label: 'Other', value: 'Other' },
];
